export const CREDIT_FORM_ID = '#form-finance-credit';

export const creditForm = $(CREDIT_FORM_ID);
export const models = creditForm.find('.finance__model');
export const complectationsField = creditForm.find('[data-complectation]');
export const srokInput = creditForm.find('[name=srok]');
export const creditFields = $('.finance').find('[data-finance]');

export const settings = {
  MIN_CREDIT_PERCENT: 0.0,
  MIN_CREDIT: 0,
  MAX_CREDIT_PERCENT: 1,
  MAX_CREDIT: 0,
  SZH: 0.0,
  GAP: 0.0,
  MONTH: 48,
  SROK: 48,
  YEARS: 1,
  STAVKA: 0.0,
};

export const TRADE_IN_ID = 3;
export const CHANGAN_FINANCE_ID = 4;
export const TRADE_IN_OTHER_ID = 5;
export const BENEFIT = 6;
export const DIRECT_SALE_ID = 2;
